// Modal component - no longer needed as WharfKit handles its own UI
const Modals = () => {
  return null;
};

export default Modals;
